/**
 * Pure utility functions for selection position calculations
 */

export interface SelectionBounds {
  startTime: number;
  duration: number;
}

export interface ViewportInfo {
  containerWidth: number;
  stripWidth: number;
  videoDuration: number;
}

/**
 * Convert selection time to absolute pixel position on the strip
 */
export function timeToAbsolutePixel(
  time: number,
  videoDuration: number,
  stripWidth: number
): number {
  if (videoDuration <= 0) return 0;
  return (time / videoDuration) * stripWidth;
}

/**
 * Constrain a time value to valid selection bounds
 */
export function constrainSelectionTime(
  time: number,
  duration: number,
  videoDuration: number
): number {
  return Math.max(0, Math.min(videoDuration - duration, time));
}
